export enum transferTypes {
  bank = "bank",
  intraGateway = "intraGateway",
  interGateway = "interGateway",
}
